import { createContext, useContext } from 'react';
import type { Profile } from '@/data/types';
import type { SessionInfo } from '@/data/auth';

export interface SessionValue {
  session: SessionInfo;
  profile: Profile;
  /** False until the user finishes (or skips) onboarding on this device. */
  onboardingComplete: boolean;
  completeOnboarding: () => Promise<void>;
  /** Persist profile changes locally and mirror them to the backend. */
  updateProfile: (patch: Partial<Profile>) => Promise<void>;
  refresh: () => Promise<void>;
}

export const SessionContext = createContext<SessionValue | null>(null);

/** Session and profile for the signed-in (or guest) user. Throws outside the provider. */
export function useSession(): SessionValue {
  const value = useContext(SessionContext);
  if (value === null) throw new Error('useSession must be used inside <SessionProvider>');
  return value;
}
